module.exports = __webpack_public_path__ + "27487113a297ed7ea1dfeee1a42539d4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image9.png
 ** module id = 287
 ** module chunks = 0
 **/